// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AgregarTotemsPage_containerCuerpo__Y1o80 {
  background-color: white;
}

.AgregarTotemsPage_divFormulario__JGF59 {
}

.AgregarTotemsPage_containerFilaBusqueda__qPc-e {
  display: flex;

  align-items: center;
  padding: 0px;
  width: 100%;
  margin: 0px;
  justify-content: space-between;
}

.AgregarTotemsPage_titulo__YK8it {
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--text-color);
  margin-bottom: 20px;
  justify-self: flex-start;
  text-align: left;
  width: 100%;
  display: flex;
}

.AgregarTotemsPage_divTodoEnUnaFila__gVUVP {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
}

.AgregarTotemsPage_divCampos__y34EV {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 10px;
  margin-right: 10px;
}

.AgregarTotemsPage_divCamposItem__ipqrj {
  display: flex;
  flex-direction: row;
  margin-left: 0px;
  text-wrap: wrap;
  word-wrap: break-word;
}

.AgregarTotemsPage_atributo__FlQ\\+7 {
  font-size: 0.8rem;
  font-weight: bold;
  text-wrap: nowrap;
  text-align: left;
  color: var(--text-color-claro);
}

.AgregarTotemsPage_valor__Oc4AW {
  font-size: 0.8rem;
  color: var(--text-color-claro-2);
  margin-left: 5px;
  text-align: left;
  word-wrap: break-word;
  max-width: 100%;
}

.AgregarTotemsPage_labelAgregarTotems__8RST5 {
  font-weight: bold;
  font-size: 1.3rem;
  color: black;
  margin-top: 20px;
  text-align: center; /* Centra el texto dentro del label */
  display: flex; /* Usa flexbox para alinear el contenido */
  justify-content: center; /* Alinea horizontalmente al centro */
  width: 100%;
}

.AgregarTotemsPage_labelTituloTotems__qvvBZ {
  font-weight: bold;
  font-size: 1.2rem;
  color: black;
  margin-top: 20px;
  text-align: left; /* Centra el texto dentro del label */
  display: flex; /* Usa flexbox para alinear el contenido */
  justify-content: flex-start; /* Alinea horizontalmente al centro */
  width: 100%;
}

.AgregarTotemsPage_divBotonera__JT3qd {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.AgregarTotemsPage_circleImage__NH63N {
  width: 100%; /* Ajusta el tamaño según tus necesidades */
  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 8px; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 0px;
  border-width: 1px;
  border-style: solid;
}

.AgregarTotemsPage_containerUsuario__UhKWk {
  width: 100%;
  border-radius: 15px;
  border-color: gray;
  border-width: 1px;
  border-style: solid;
  padding: 10px;
  margin: 10px; /* Agrega un poco de margen entre los botones */
}

.AgregarTotemsPage_divCampos__y34EV {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  justify-items: flex-start;
  margin-left: 10px;
}
.AgregarTotemsPage_contenedorTotemActivo__jXh-v {
  display: flex;
  width: 100%;
  border-style: solid;
  border-radius: 20px;
  border-width: 1px;
  flex-direction: row;
  flex-wrap: wrap; /* Añade envoltura */
  margin-top: 20px;
  box-shadow: 0 4px 8px rgba(113, 113, 113, 0.8),
    /* Sombra principal */ 0 6px 20px rgba(0, 0, 0, 0.1); /* Sombra más difuminada para un efecto más profundo */
}

.AgregarTotemsPage_contenedorTotemActivo__jXh-v .AgregarTotemsPage_icono__TSZNb {
  flex: 1 1 15%; /* Usa flex-grow y flex-shrink para ajustar automáticamente */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  margin-top: 20px;
}

.AgregarTotemsPage_contenedorTotemActivo__jXh-v .AgregarTotemsPage_info__UBVFX {
  flex: 1 1 50%; /* Ajusta según sea necesario */
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 10px;
  margin-bottom: 20px;
}

.AgregarTotemsPage_contenedorTotemActivo__jXh-v .AgregarTotemsPage_botones__jSwp- {
  flex: 1 1 25%; /* Ajusta según sea necesario */
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  align-items: center;
  gap: 20px;
}

.AgregarTotemsPage_contenedorTotemInactivo__mjMLz {
  display: flex;
  width: 100%;
  height: 140px;
  border-style: solid;
  border-radius: 20px;
  border-width: 1px;
  flex-direction: column;
  margin-top: 20px;
  align-items: center;
  justify-content: center;
  gap: 20px;

  background-color: var(--gris-fondo); /* Color de fondo */
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.2),
    /* Sombra interna más oscura */ inset 0 6px 20px rgba(0, 0, 0, 0.25); /* Sombra interna más grande y más difusa */
}

/* Media query para pantallas pequeñas */

@media (min-width: 768px) {
  /* Ajusta este valor según tus necesidades */

  .AgregarTotemsPage_divCampos__y34EV {
    flex-direction: row;
    gap: 30px;
  }

  .AgregarTotemsPage_containerGrillaUsuarios__gUS2V {
    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */
    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */
  }

  .AgregarTotemsPage_circleImage__NH63N {
    width: 50%; /* Ajusta el tamaño según tus necesidades */

    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */

    border-width: 1px;
    border-style: solid;
  }

  .AgregarTotemsPage_atributo__FlQ\\+7 {
    font-size: 1rem;
    width: 30%;
  }

  .AgregarTotemsPage_valor__Oc4AW {
    font-size: 1rem;
    width: 70%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/panel/licencias/agregar-totems/AgregarTotemsPage.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;AACA;;AAEA;EACE,aAAa;;EAEb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB,EAAE,qCAAqC;EACzD,aAAa,EAAE,0CAA0C;EACzD,uBAAuB,EAAE,qCAAqC;EAC9D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB,EAAE,qCAAqC;EACvD,aAAa,EAAE,0CAA0C;EACzD,2BAA2B,EAAE,qCAAqC;EAClE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW,EAAE,2CAA2C;EACxD,aAAa,EAAE,8EAA8E;EAC7F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,YAAY,EAAE,+CAA+C;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe,EAAE,oBAAoB;EACrC,gBAAgB;EAChB;wDACsD,EAAE,sDAAsD;AAChH;;AAEA;EACE,aAAa,EAAE,6DAA6D;EAC5E,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,+BAA+B;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa,EAAE,+BAA+B;EAC9C,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET,mCAAmC,EAAE,mBAAmB;EACxD;wEACsE,EAAE,2CAA2C;AACrH;;AAEA,wCAAwC;;AAExC;EACE,4CAA4C;;EAE5C;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,mBAAmB,EAAE,sEAAsE;IAC3F,eAAe,EAAE,mFAAmF;IACpG,2BAA2B,EAAE,qDAAqD;EACpF;;EAEA;IACE,UAAU,EAAE,2CAA2C;;IAEvD,iBAAiB,EAAE,wEAAwE;;IAE3F,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;AACF","sourcesContent":[".containerCuerpo {\n  background-color: white;\n}\n\n.divFormulario {\n}\n\n.containerFilaBusqueda {\n  display: flex;\n\n  align-items: center;\n  padding: 0px;\n  width: 100%;\n  margin: 0px;\n  justify-content: space-between;\n}\n\n.titulo {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: var(--text-color);\n  margin-bottom: 20px;\n  justify-self: flex-start;\n  text-align: left;\n  width: 100%;\n  display: flex;\n}\n\n.divTodoEnUnaFila {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.divCamposItem {\n  display: flex;\n  flex-direction: row;\n  margin-left: 0px;\n  text-wrap: wrap;\n  word-wrap: break-word;\n}\n\n.atributo {\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-wrap: nowrap;\n  text-align: left;\n  color: var(--text-color-claro);\n}\n\n.valor {\n  font-size: 0.8rem;\n  color: var(--text-color-claro-2);\n  margin-left: 5px;\n  text-align: left;\n  word-wrap: break-word;\n  max-width: 100%;\n}\n\n.labelAgregarTotems {\n  font-weight: bold;\n  font-size: 1.3rem;\n  color: black;\n  margin-top: 20px;\n  text-align: center; /* Centra el texto dentro del label */\n  display: flex; /* Usa flexbox para alinear el contenido */\n  justify-content: center; /* Alinea horizontalmente al centro */\n  width: 100%;\n}\n\n.labelTituloTotems {\n  font-weight: bold;\n  font-size: 1.2rem;\n  color: black;\n  margin-top: 20px;\n  text-align: left; /* Centra el texto dentro del label */\n  display: flex; /* Usa flexbox para alinear el contenido */\n  justify-content: flex-start; /* Alinea horizontalmente al centro */\n  width: 100%;\n}\n\n.divBotonera {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.circleImage {\n  width: 100%; /* Ajusta el tamaño según tus necesidades */\n  height: 150px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 8px; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 0px;\n  border-width: 1px;\n  border-style: solid;\n}\n\n.containerUsuario {\n  width: 100%;\n  border-radius: 15px;\n  border-color: gray;\n  border-width: 1px;\n  border-style: solid;\n  padding: 10px;\n  margin: 10px; /* Agrega un poco de margen entre los botones */\n}\n\n.divCampos {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  align-content: flex-start;\n  justify-content: flex-start;\n  justify-items: flex-start;\n  margin-left: 10px;\n}\n.contenedorTotemActivo {\n  display: flex;\n  width: 100%;\n  border-style: solid;\n  border-radius: 20px;\n  border-width: 1px;\n  flex-direction: row;\n  flex-wrap: wrap; /* Añade envoltura */\n  margin-top: 20px;\n  box-shadow: 0 4px 8px rgba(113, 113, 113, 0.8),\n    /* Sombra principal */ 0 6px 20px rgba(0, 0, 0, 0.1); /* Sombra más difuminada para un efecto más profundo */\n}\n\n.contenedorTotemActivo .icono {\n  flex: 1 1 15%; /* Usa flex-grow y flex-shrink para ajustar automáticamente */\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  align-content: flex-start;\n  margin-top: 20px;\n}\n\n.contenedorTotemActivo .info {\n  flex: 1 1 50%; /* Ajusta según sea necesario */\n  display: flex;\n  flex-direction: column;\n  margin-top: 20px;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.contenedorTotemActivo .botones {\n  flex: 1 1 25%; /* Ajusta según sea necesario */\n  display: flex;\n  flex-direction: column;\n  padding-top: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-bottom: 10px;\n  align-items: center;\n  gap: 20px;\n}\n\n.contenedorTotemInactivo {\n  display: flex;\n  width: 100%;\n  height: 140px;\n  border-style: solid;\n  border-radius: 20px;\n  border-width: 1px;\n  flex-direction: column;\n  margin-top: 20px;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n\n  background-color: var(--gris-fondo); /* Color de fondo */\n  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.2),\n    /* Sombra interna más oscura */ inset 0 6px 20px rgba(0, 0, 0, 0.25); /* Sombra interna más grande y más difusa */\n}\n\n/* Media query para pantallas pequeñas */\n\n@media (min-width: 768px) {\n  /* Ajusta este valor según tus necesidades */\n\n  .divCampos {\n    flex-direction: row;\n    gap: 30px;\n  }\n\n  .containerGrillaUsuarios {\n    flex-direction: row; /* Cambio en la dirección de flex para alinear los elementos en fila */\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan en la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Distribuye el espacio alrededor de los elementos */\n  }\n\n  .circleImage {\n    width: 50%; /* Ajusta el tamaño según tus necesidades */\n\n    object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n\n    border-width: 1px;\n    border-style: solid;\n  }\n\n  .atributo {\n    font-size: 1rem;\n    width: 30%;\n  }\n\n  .valor {\n    font-size: 1rem;\n    width: 70%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerCuerpo": `AgregarTotemsPage_containerCuerpo__Y1o80`,
	"divFormulario": `AgregarTotemsPage_divFormulario__JGF59`,
	"containerFilaBusqueda": `AgregarTotemsPage_containerFilaBusqueda__qPc-e`,
	"titulo": `AgregarTotemsPage_titulo__YK8it`,
	"divTodoEnUnaFila": `AgregarTotemsPage_divTodoEnUnaFila__gVUVP`,
	"divCampos": `AgregarTotemsPage_divCampos__y34EV`,
	"divCamposItem": `AgregarTotemsPage_divCamposItem__ipqrj`,
	"atributo": `AgregarTotemsPage_atributo__FlQ+7`,
	"valor": `AgregarTotemsPage_valor__Oc4AW`,
	"labelAgregarTotems": `AgregarTotemsPage_labelAgregarTotems__8RST5`,
	"labelTituloTotems": `AgregarTotemsPage_labelTituloTotems__qvvBZ`,
	"divBotonera": `AgregarTotemsPage_divBotonera__JT3qd`,
	"circleImage": `AgregarTotemsPage_circleImage__NH63N`,
	"containerUsuario": `AgregarTotemsPage_containerUsuario__UhKWk`,
	"contenedorTotemActivo": `AgregarTotemsPage_contenedorTotemActivo__jXh-v`,
	"icono": `AgregarTotemsPage_icono__TSZNb`,
	"info": `AgregarTotemsPage_info__UBVFX`,
	"botones": `AgregarTotemsPage_botones__jSwp-`,
	"contenedorTotemInactivo": `AgregarTotemsPage_contenedorTotemInactivo__mjMLz`,
	"containerGrillaUsuarios": `AgregarTotemsPage_containerGrillaUsuarios__gUS2V`
};
export default ___CSS_LOADER_EXPORT___;
